export default "__VITE_PUBLIC_ASSET__487f9081__"